import type { PromoCandidate } from '@supply-mover-2-0/shared';
import type { JSX } from 'react';
import { PromoTile } from './PromoTile';

/**
 * Single feature tile. Visually similar to banner but in a smaller
 * grid cell — renders the first selected promo at feature size.
 */
export function PromoOneUpWidget({
	promos,
	density,
	onLikelyStaleUrl,
}: {
	promos: Array<PromoCandidate>;
	density?: 'standard' | 'compact';
	onLikelyStaleUrl?: () => void;
}): JSX.Element | null {
	const promo = promos[0];
	if (promo == null) return null;
	return (
		<div className="w-full h-full">
			<PromoTile
				promo={promo as never}
				size="feature"
				density={density}
				onLikelyStaleUrl={onLikelyStaleUrl}
			/>
		</div>
	);
}
